import React, { Component } from 'react'

import { BrowserRouter as Router, Switch, Redirect, Route } from 'react-router-dom'

import ApolloClient from 'apollo-boost'
import { ApolloProvider } from 'react-apollo'

import AppContainer from 'containers/AppContainer'

import DashboardPage from 'pages/DashboardPage'
import SettingsPage from 'pages/SettingsPage'
import SwitchHousePage from 'pages/SwitchHousePage'
import InvitationPage from 'pages/InvitationPage'

import { GRAPHQL_URI, AUTH_TOKEN_KEY } from './constants'

const client = new ApolloClient({
  uri: GRAPHQL_URI,
  request: (operation) => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY)
    const authorizationHeader = token ? `JWT ${token}` : null
    operation.setContext({
      headers: {
        authorization: authorizationHeader,
        'Accept-Language': 'pt-BR' // Temporarily
      }
    })
    return operation
  }
})

export default class Root extends Component {
  render() {
    return (
      <ApolloProvider client={client}>
        <Router basename="/web">
          <AppContainer>
            <Switch>
              <Route path="/dashboard" component={DashboardPage} />
              <Route path="/settings" component={SettingsPage} />
              <Route path="/switch" component={SwitchHousePage} />
              <Route path="/invitations/:invitationId" component={InvitationPage} />
              <Redirect to="/dashboard" />
            </Switch>
          </AppContainer>
        </Router>
      </ApolloProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Root.js